import React from 'react';
import './index.scss';

const toHTML = str => ({ __html: str });

const RichText = ({ text, className = '' }) => {
	return <div className={`${className} rich_text_container`} dangerouslySetInnerHTML={toHTML(text)}/>;
};

export default RichText;